import LayoutBuilder from './classes/services/layout-builder.js';
import LayoutUpdater from './classes/services/layout-updater.js';
import Hubspot from './classes/services/hubspot.js';
import GoogleTagManager from './classes/services/gtm.js';
import CookieConsent from './classes/services/cookie-consent.js';

const layoutUpdater = new LayoutUpdater();

$(document).ready(function() {
  const layoutBuilder = new LayoutBuilder();
  layoutBuilder.build();
  layoutUpdater.update();
});

$(document).ajaxComplete(function() {
  layoutUpdater.update();
});

$(window).load(() => {
  eval(
    `hbspt.forms.create({ region: 'na1', portalId: '5246303', formId: '53013292-7d70-4628-a81b-48eed91cced5' })`
  );

  window.addEventListener('message', event => {
    if (
      event.data.type === 'hsFormCallback' &&
      event.data.eventName === 'onFormReady'
    ) {
      Hubspot.inject();
      if (ENABLE_STAT_COLLECTING) GoogleTagManager.inject();
      CookieConsent.inject();
      const currentTheme = localStorage.getItem('rapydDocsTheme') || 'light';
      $(document.querySelector('iframe.hs-form-iframe'))
        .contents()
        .find('html')
        .attr('data-theme', currentTheme);
    }
  });
});
